import { lazy } from 'react';

import { AppRoute } from '.';

const PublishedArtifact = lazy(
  () => import('../pages/public/PublishedArtifact/PublishedArtifact'),
);

const Integration = lazy(
  () => import('../pages/private/Integration/Integration'),
);
const SSOCallback = lazy(
  () => import('../pages/public/SSOCallback/SSOCallback'),
);
const Account = lazy(() => import('../pages/private/Account/Account'));
const Login = lazy(() => import('../pages/public/Login/Login'));
const SSOLogin = lazy(() => import('../pages/public/SSOLogin/SSOLogin'));
const LoginMfa = lazy(() => import('../pages/public/LoginMfa/LoginMfa'));
const Signup = lazy(() => import('../pages/public/Signup/Signup'));
const Waitlist = lazy(() => import('../pages/public/Waitlist/Waitlist'));
const ResetPassword = lazy(
  () => import('../pages/public/ResetPassword/ResetPassword'),
);
const Tutorial = lazy(() => import('../pages/public/Tutorial/Tutorial'));
const Support = lazy(() => import('../pages/private/Support/Support'));
const Team = lazy(() => import('../pages/private/Team/Team'));
const BrainSignalDetailPage = lazy(
  () => import('../pages/private/Team/SignalDetail/SignalDetailPage'),
);
const InboxOverview = lazy(
  () => import('../pages/private/Inbox/InboxOverview/InboxOverview'),
);
const InboxScheduled = lazy(
  () => import('../pages/private/Inbox/InboxScheduled/InboxScheduled'),
);
const InboxSnoozed = lazy(
  () => import('../pages/private/Inbox/InboxSnoozed/InboxSnoozed'),
);
const InboxPreview = lazy(
  () => import('../pages/private/Inbox/InboxPreview/InboxPreview'),
);

const DoBox = lazy(() => import('../pages/private/DoBox/DoBox'));
const SpecPage = lazy(
  () => import('../pages/private/DoBox/Spec/SpecPage/SpecPage'),
);

const InboxSent = lazy(
  () => import('../pages/private/Inbox/InboxSent/InboxSent'),
);
const InboxDraft = lazy(
  () => import('../pages/private/Inbox/InboxDraft/InboxDraft'),
);
const InboxSpam = lazy(
  () => import('../pages/private/Inbox/InboxSpam/InboxSpam'),
);
const InboxTrash = lazy(
  () => import('../pages/private/Inbox/InboxTrash/InboxTrash'),
);
const InboxAll = lazy(() => import('../pages/private/Inbox/InboxAll/InboxAll'));
const InboxLabels = lazy(
  () => import('../pages/private/Inbox/InboxLabels/InboxLabels'),
);
const InboxSearch = lazy(
  () => import('../pages/private/Inbox/InboxSearch/InboxSearch'),
);
const SlackInboxOverview = lazy(
  () =>
    import('../pages/private/SlackInbox/SlackInboxOverview/SlackInboxOverview'),
);
const SlackConversationPreview = lazy(
  () =>
    import(
      '../pages/private/SlackInbox/SlackConversationPreview/SlackConversationPreview'
    ),
);
const TeamsInboxOverview = lazy(
  () =>
    import('../pages/private/TeamsInbox/TeamsInboxOverview/TeamsInboxOverview'),
);
const TeamsConversationPreview = lazy(
  () =>
    import(
      '../pages/private/TeamsInbox/TeamsConversationPreview/TeamsConversationPreview'
    ),
);
const InstagramInboxOverview = lazy(
  () =>
    import(
      '../pages/private/InstagramInbox/InstagramInboxOverview/InstagramInboxOverview'
    ),
);
const InstagramConversationPreview = lazy(
  () =>
    import(
      '../pages/private/InstagramInbox/InstagramConversationPreview/InstagramConversationPreview'
    ),
);
const Onboarding = lazy(() => import('../pages/private/Onboarding/Onboarding'));
const Assistant = lazy(() => import('../pages/private/Assistant/Assistant'));
const AssistantSettings = lazy(
  () => import('../pages/private/AssistantSettings/AssistantSettings'),
);
const AssistantMemoryRedirect = lazy(
  () => import('../pages/private/AssistantSettings/AssistantMemoryRedirect'),
);
const Flows = lazy(() => import('../pages/private/Flows/Flows'));
const FlowsDiscoverRedirect = lazy(
  () => import('../pages/private/Flows/FlowsDiscoverRedirect'),
);
const Billing = lazy(() => import('../pages/private/Billing/Billing'));
const Credits = lazy(() => import('../pages/private/Credits/Credits'));
const Brain = lazy(() => import('../pages/private/Brain/Brain'));
const Calendar = lazy(() => import('../pages/private/Calendar/Calendar'));
const Contacts = lazy(() => import('../pages/private/Contacts/Contacts'));
const GeneratedImages = lazy(
  () => import('../pages/private/GeneratedImages/GeneratedImagesPage'),
);
const FlowEditor = lazy(
  () => import('../pages/private/Flows/FlowEditor/FlowEditor'),
);
const AutomationChat = lazy(
  () => import('../pages/private/Flows/AutomationChat/AutomationChat'),
);
const FlowGroupEditor = lazy(
  () =>
    import('../pages/private/Flows/FlowGroups/FlowGroupEditor/FlowGroupEditor'),
);
const McpOauthCallback = lazy(
  () => import('../pages/private/McpOauthCallback/McpOauthCallback'),
);
export const ROUTE_PARAM_ID = '/:id';

export const ALLOWED_REDIRECT_HOSTS = [
  'accounts.thisandthat.chat',
  'clerk.thisandthat.chat',
];

export const INBOX_PREVIEW_QUERY_PARAMS = {
  FROM: 'from',
  DOBOX_ID: 'doboxId',
  DRAFT: 'draft',
} as const;

export const INBOX_PREVIEW_FROM_VALUES = {
  LABELS: 'labels',
  SNOOZED: 'snoozed',
  DOBOX: 'dobox',
} as const;

export enum APP_PAGES {
  ROOT = '/',
  SIGNUP = '/signup',
  WAITLIST = '/waitlist',
  LOGIN = '/login',
  SSO_LOGIN = '/sso-login',
  LOGIN_MFA = '/login/mfa',
  RESET_PASSWORD = '/reset-password',
  ONBOARDING_BASE = '/onboarding',
  ONBOARDING = '/onboarding/:step',
  ACCOUNT = '/account',
  INTEGRATION = '/integration/*',
  SSO_CALLBACK = '/sso_callback',
  SSO_DASH_CALLBACK = '/sso-callback',
  TUTORIAL = '/tutorial',
  SUPPORT = '/support',
  TEAM = '/team',
  TEAM_DETAIL = '/team/:teamId',
  TEAM_SIGNAL_DETAIL = '/team/:teamId/signals/:signalId',
  INBOX = '/inbox',
  INBOX_SCHEDULED = '/inbox/scheduled',
  INBOX_SNOOZED = '/inbox/snoozed',
  INBOX_PREVIEW = '/inbox/preview/:id',
  DOBOX_PREVIEW = '/do-box/preview/:id',
  DOBOX_SPEC = '/do-box/specs/:id',
  DOBOX = '/do-box',
  INBOX_SENT = '/inbox/sent',
  INBOX_DRAFT = '/inbox/draft',
  INBOX_SPAM = '/inbox/spam',
  INBOX_TRASH = '/inbox/trash',
  INBOX_ALL = '/inbox/all',
  INBOX_LABELS = '/inbox/labels',
  INBOX_SEARCH = '/inbox/search',
  SLACK_INBOX_OVERVIEW = '/inbox/slack',
  SLACK_INBOX_CHANNEL = '/inbox/slack/channel/:id',
  SLACK_INBOX_DIRECT = '/inbox/slack/direct/:id',
  TEAMS_INBOX_OVERVIEW = '/inbox/teams',
  TEAMS_INBOX_GROUP = '/inbox/teams/group/:id',
  TEAMS_INBOX_CHAT = '/inbox/teams/chat/:id',
  INSTAGRAM_INBOX_OVERVIEW = '/inbox/instagram',
  INSTAGRAM_INBOX_DM = '/inbox/instagram/dm/:id',
  ASSISTANT = '/assistant',
  // Registered (enum AND route-array order) before ASSISTANT_CONVERSATION:
  // the dynamic ':conversationId' segment would otherwise shadow this static
  // path and open an empty conversation titled "memory".
  ASSISTANT_SETTINGS = '/assistant/settings',
  ASSISTANT_MEMORY_LEGACY = '/assistant/memory',
  ASSISTANT_CONVERSATION = '/assistant/:conversationId',
  BILLING = '/billing',
  CREDITS = '/credits',
  BRAIN = '/brain',
  BRAIN_FAVORITES = '/brain/favorites',
  CALENDAR = '/calendar',
  CONTACTS = '/contacts',
  CONTACTS_DETAIL = '/contacts/:personId',
  BRAIN_PAGE = '/brain/:pageId',
  BRAIN_SPACE = '/brain/space/:spaceId',
  FLOWS = '/flows',
  FLOWS_DISCOVER = '/flows/discover',
  FLOW_NEW = '/flows/new',
  FLOW_EDITOR_NEW = '/flows/editor/new',
  FLOW_GROUP_NEW = '/flows/groups/new',
  FLOW_GROUP_EDITOR = '/flows/groups/:groupId',
  FLOW_EDITOR = '/flows/:flowId',
  PUBLISHED_ARTIFACT = '/a/:slug',
  GENERATED_IMAGES = '/generated-images',
  MCP_OAUTH_CALLBACK = '/integrations/mcp-oauth-callback',
}

export function buildTeamDetailPath(teamId: string): string {
  return `${APP_PAGES.TEAM}/${teamId}`;
}

export function buildBrainSignalPath(teamId: string, signalId: string): string {
  return APP_PAGES.TEAM_SIGNAL_DETAIL.replace(
    ':teamId',
    encodeURIComponent(teamId),
  ).replace(':signalId', encodeURIComponent(signalId));
}

export function buildBrainPagePath(pageId: string): string {
  return `${APP_PAGES.BRAIN}/${pageId}`;
}

export function buildBrainSpacePath(spaceId: string): string {
  return `${APP_PAGES.BRAIN}/space/${spaceId}`;
}

export function buildDoBoxPreviewPath(inboxEntryId: string): string {
  return APP_PAGES.DOBOX_PREVIEW.replace(':id', inboxEntryId);
}

export function buildDoBoxSpecPath(inboxEntryId: string): string {
  return APP_PAGES.DOBOX_SPEC.replace(':id', inboxEntryId);
}

export function buildInboxPreviewPath(
  messageId: string,
  options?: { from?: string; doboxId?: string; draftId?: string },
): string {
  const path = APP_PAGES.INBOX_PREVIEW.replace(
    ':id',
    encodeURIComponent(messageId),
  );
  const params = new URLSearchParams();

  if (options?.from) {
    params.set(INBOX_PREVIEW_QUERY_PARAMS.FROM, options.from);
  }
  if (options?.doboxId) {
    params.set(INBOX_PREVIEW_QUERY_PARAMS.DOBOX_ID, options.doboxId);
  }
  if (options?.draftId) {
    params.set(INBOX_PREVIEW_QUERY_PARAMS.DRAFT, options.draftId);
  }

  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

export function buildContactDetailPath(routeId: string): string {
  return APP_PAGES.CONTACTS_DETAIL.replace(
    ':personId',
    encodeURIComponent(routeId),
  );
}

export function buildFlowsHubPath(tab: string): string {
  return `${APP_PAGES.FLOWS}?tab=${tab}`;
}

export function buildFlowEditorPath(flowId: string): string {
  return APP_PAGES.FLOW_EDITOR.replace(':flowId', encodeURIComponent(flowId));
}

export const VIEW_ONLY_QUERY_PARAM = 'view';
export const VIEW_ONLY_QUERY_VALUE = 'true';

export function buildFlowViewOnlyPath(flowId: string): string {
  return `${buildFlowEditorPath(flowId)}?${VIEW_ONLY_QUERY_PARAM}=${VIEW_ONLY_QUERY_VALUE}`;
}

export const BUILDER_VIEW_QUERY_PARAM = 'builder';

export function buildFlowBuilderPath(flowId: string): string {
  return `${buildFlowEditorPath(flowId)}?${BUILDER_VIEW_QUERY_PARAM}=1`;
}

export function buildFlowGroupEditorPath(groupId: string): string {
  return APP_PAGES.FLOW_GROUP_EDITOR.replace(
    ':groupId',
    encodeURIComponent(groupId),
  );
}

export function buildFlowGroupBuilderPath(groupId: string): string {
  return `${buildFlowGroupEditorPath(groupId)}?${BUILDER_VIEW_QUERY_PARAM}=1`;
}

export const universalRoutes: AppRoute[] = [
  {
    element: Signup,
    path: APP_PAGES.SIGNUP,
  },
  {
    element: Waitlist,
    path: APP_PAGES.WAITLIST,
  },
  {
    element: Support,
    path: APP_PAGES.SUPPORT,
  },
  {
    element: PublishedArtifact,
    path: APP_PAGES.PUBLISHED_ARTIFACT,
  },
];

export const publicRoutes: AppRoute[] = [
  {
    element: Login,
    path: APP_PAGES.LOGIN,
  },
  {
    element: SSOLogin,
    path: APP_PAGES.SSO_LOGIN,
  },
  {
    element: LoginMfa,
    path: APP_PAGES.LOGIN_MFA,
  },
  {
    element: ResetPassword,
    path: APP_PAGES.RESET_PASSWORD,
  },
  {
    element: SSOCallback,
    path: APP_PAGES.SSO_CALLBACK,
  },
  {
    element: SSOCallback,
    path: APP_PAGES.SSO_DASH_CALLBACK,
  },
];

export const privateRoutes: AppRoute[] = [
  {
    element: Account,
    path: APP_PAGES.ACCOUNT,
  },
  {
    element: Integration,
    path: APP_PAGES.INTEGRATION,
  },
  {
    element: Onboarding,
    path: APP_PAGES.ONBOARDING,
  },
  {
    element: Tutorial,
    path: APP_PAGES.TUTORIAL,
  },
  {
    element: Team,
    path: APP_PAGES.TEAM,
  },
  {
    element: Team,
    path: APP_PAGES.TEAM_DETAIL,
  },
  {
    element: BrainSignalDetailPage,
    path: APP_PAGES.TEAM_SIGNAL_DETAIL,
  },
  {
    element: InboxOverview,
    path: APP_PAGES.INBOX,
  },
  {
    element: InboxScheduled,
    path: APP_PAGES.INBOX_SCHEDULED,
  },
  {
    element: InboxSnoozed,
    path: APP_PAGES.INBOX_SNOOZED,
  },
  {
    element: InboxPreview,
    path: APP_PAGES.INBOX_PREVIEW,
  },
  {
    element: InboxPreview,
    path: APP_PAGES.DOBOX_PREVIEW,
  },
  {
    element: SpecPage,
    path: APP_PAGES.DOBOX_SPEC,
  },
  {
    element: DoBox,
    path: APP_PAGES.DOBOX,
  },
  { element: InboxSent, path: APP_PAGES.INBOX_SENT },
  { element: InboxDraft, path: APP_PAGES.INBOX_DRAFT },
  { element: InboxSpam, path: APP_PAGES.INBOX_SPAM },
  { element: InboxTrash, path: APP_PAGES.INBOX_TRASH },
  { element: InboxAll, path: APP_PAGES.INBOX_ALL },
  { element: InboxLabels, path: APP_PAGES.INBOX_LABELS },
  { element: InboxSearch, path: APP_PAGES.INBOX_SEARCH },
  {
    element: SlackInboxOverview,
    path: APP_PAGES.SLACK_INBOX_OVERVIEW,
  },
  {
    element: SlackConversationPreview,
    path: APP_PAGES.SLACK_INBOX_CHANNEL,
  },
  {
    element: SlackConversationPreview,
    path: APP_PAGES.SLACK_INBOX_DIRECT,
  },
  {
    element: TeamsInboxOverview,
    path: APP_PAGES.TEAMS_INBOX_OVERVIEW,
  },
  {
    element: TeamsConversationPreview,
    path: APP_PAGES.TEAMS_INBOX_GROUP,
  },
  {
    element: TeamsConversationPreview,
    path: APP_PAGES.TEAMS_INBOX_CHAT,
  },
  {
    element: InstagramInboxOverview,
    path: APP_PAGES.INSTAGRAM_INBOX_OVERVIEW,
  },
  {
    element: InstagramConversationPreview,
    path: APP_PAGES.INSTAGRAM_INBOX_DM,
  },
  {
    element: Assistant,
    path: APP_PAGES.ASSISTANT,
  },
  {
    element: AssistantSettings,
    path: APP_PAGES.ASSISTANT_SETTINGS,
  },
  {
    element: AssistantMemoryRedirect,
    path: APP_PAGES.ASSISTANT_MEMORY_LEGACY,
  },
  {
    element: Assistant,
    path: APP_PAGES.ASSISTANT_CONVERSATION,
  },
  {
    element: Billing,
    path: APP_PAGES.BILLING,
  },
  {
    element: Credits,
    path: APP_PAGES.CREDITS,
  },
  {
    element: Flows,
    path: APP_PAGES.FLOWS,
  },
  {
    element: FlowsDiscoverRedirect,
    path: APP_PAGES.FLOWS_DISCOVER,
  },
  {
    element: AutomationChat,
    path: APP_PAGES.FLOW_NEW,
  },
  {
    element: FlowEditor,
    path: APP_PAGES.FLOW_EDITOR_NEW,
  },
  {
    element: FlowGroupEditor,
    path: APP_PAGES.FLOW_GROUP_NEW,
  },
  {
    element: FlowGroupEditor,
    path: APP_PAGES.FLOW_GROUP_EDITOR,
  },
  {
    element: FlowEditor,
    path: APP_PAGES.FLOW_EDITOR,
  },
  { element: Brain, path: APP_PAGES.BRAIN },
  { element: Calendar, path: APP_PAGES.CALENDAR },
  { element: Contacts, path: APP_PAGES.CONTACTS },
  { element: Contacts, path: APP_PAGES.CONTACTS_DETAIL },
  { element: Brain, path: APP_PAGES.BRAIN_FAVORITES },
  { element: Brain, path: APP_PAGES.BRAIN_PAGE },
  { element: Brain, path: APP_PAGES.BRAIN_SPACE },
  { element: GeneratedImages, path: APP_PAGES.GENERATED_IMAGES },
  { element: McpOauthCallback, path: APP_PAGES.MCP_OAUTH_CALLBACK },
];
